import React from 'react';
import "./Footer.css";
import { FaHome, FaGithub, FaTwitter, FaLinkedin } from "react-icons/fa";


function Footer() {
    return (
        <div className="footer">
            <div className="footer-container">
                <div className="left">
                    <div className="location">
                        <FaHome size={20} style={{ color: "white", marginRight: "2rem" }} />
                        <div>
                            <p>Hyderabad</p>
                            <p>India</p>
                        </div>
                    </div>
                </div>
                <div className="right">
                    <h4>About me</h4>
                    <p>I am Shyam Khade , a full-stack developer with expertise in the MERN stack, including MongoDB, Express, React, and Node.js.I have a passion for building high-performance, scalable web applications that meet the needs of users and businesses alike!
                    </p>
                    <div className="social">
                        <a href="https://www.linkedin.com/in/shyam-khade-35824821b/">
                            <FaLinkedin
                                size={20}
                                style={{ color: "white", marginRight: "1rem" }} />
                        </a>
                        <a href="https://github.com/khadeshyam">
                            <FaGithub
                                size={20}
                                style={{ color: "white", marginRight: "1rem" }}
                                 />
                        </a>
                        <a href="https://twitter.com/shyam_2056">
                            <FaTwitter
                                size={20}
                                style={{ color: "white", marginRight: "1rem" }}
                                />
                        </a>

                    </div>
                </div>
            </div>
        </div>
    )
}

export default Footer;